export default __webpack_public_path__ + "static/media/icon_activity2.7f9b2810.svg";